import React from 'react'
import PropTypes from 'prop-types'

import StoryHeader from './StoryHeader'

import { FB_PAGE_CHOICE, FB_SPONSOR_PAGE_ID, STORIES_ITEMS } from '../../../../forms/Facebook/AdForms/fields'

import InstagramStoryWrapper from './InstagramStoryWrapper'
import InstagramStoriesItem from './InstagramStoriesItem'

import useStyles from './styles'

const CarouselInstagramStoriesPreview = ({
  viewAdOnFacebook,
  formikValues,
  elementInProgress,
  fileUrl,
  handleLeftSideClick,
  handleRightSideClick,
  isSoundMuted,
  mediaThumbnailImageRatio
}) => {
  const storiesItems = formikValues[STORIES_ITEMS]
  const pageId = formikValues[FB_PAGE_CHOICE]
  const sponsorPageId = formikValues[FB_SPONSOR_PAGE_ID]

  const classes = useStyles()

  return (
    <InstagramStoryWrapper>
      <StoryHeader
        pageId={pageId}
        sponsorPageId={sponsorPageId}
        elementInProgress={elementInProgress}
        itemsCount={storiesItems.length}
      />
      <div className={classes.adStoriesCarousel}>
        {storiesItems.map((item, index) => (
          <InstagramStoriesItem
            viewAdOnFacebook={viewAdOnFacebook}
            key={index}
            formikValues={formikValues}
            elementInProgress={elementInProgress}
            fileUrl={fileUrl}
            index={index}
            handleLeftSideClick={handleLeftSideClick}
            handleRightSideClick={handleRightSideClick}
            isSoundMuted={isSoundMuted}
            mediaThumbnailImageRatio={mediaThumbnailImageRatio}
          />
        ))}
      </div>
    </InstagramStoryWrapper>
  )
}

CarouselInstagramStoriesPreview.propTypes = {
  viewAdOnFacebook: PropTypes.string,
  formikValues: PropTypes.object,
  elementInProgress: PropTypes.string,
  fileUrl: PropTypes.string,
  handleLeftSideClick: PropTypes.func,
  handleRightSideClick: PropTypes.func,
  isSoundMuted: PropTypes.bool,
  mediaThumbnailImageRatio: PropTypes.number
}

export default CarouselInstagramStoriesPreview
